import { NominalDecimal } from "@goodfill/nominal/decimal";
import Decimal from "decimal.js";

export type BondPriceNominal = NominalDecimal<"BondPriceNominal">;
export const asBondPriceNominal = (value: Decimal) => value as unknown as BondPriceNominal;

export type InterpolatedCDRate = NominalDecimal<"InterpolatedCDRate">;
export const asInterpolatedCDRate = (value: Decimal) => value as unknown as InterpolatedCDRate;

export type CouponFrequency = NominalDecimal<"CouponFrequency">;
export const asCouponFrequency = (value: Decimal) => value as unknown as CouponFrequency;

export type CouponPayment = NominalDecimal<"CouponPayment">;
export const asCouponPayment = (value: Decimal) => value as unknown as CouponPayment;

export type Yield = NominalDecimal<"Yield">;
export const asYield = (value: Decimal) => value as unknown as Yield;

export type GSpread = NominalDecimal<"GSpread">;
export const asGSpread = (value: Decimal) => value as unknown as GSpread;

export const COUPON_TYPES = ["fixed", "variable"] as const;
export type CouponType = typeof COUPON_TYPES[number];

export type MakeWholeCallSpreadBps = NominalDecimal<"MakeWholeCallSpreadBps">;
export const asMakeWholeCallSpreadBps = (value: number) => value as unknown as MakeWholeCallSpreadBps;

export type AccruedInterestRate = NominalDecimal<"AccruedInterestRate">;
export const asAccruedInterestRate = (value: Decimal) => value as unknown as AccruedInterestRate;
